import { c as _c } from "react/compiler-runtime";
import IconHide from '@/components/assets/icon_hide.svg';
import IconShow from '@/components/assets/icon_show.svg';
import { InputOTP, InputOTPGroup, InputOTPSlot, InputOTPSlotHide } from '@/components/ui/input-otp';
import { cn } from '@/lib/utils';
import { useTranslations } from 'next-intl';
import { ComponentProps, ForwardedRef, useState } from 'react';
type ViverseInputOTPProps = Omit<ComponentProps<typeof InputOTP>, 'children' | 'ref' | 'render'> & {
  maxLength: number;
  hasError?: boolean;
  defaultHidden?: boolean;
  ref?: ForwardedRef<HTMLInputElement>;
};
function ViverseInputOTP(t0) {
  const $ = _c(31);
  let hasError;
  let maxLength;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      maxLength,
      hasError,
      defaultHidden: t1,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = hasError;
    $[2] = maxLength;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
  } else {
    hasError = $[1];
    maxLength = $[2];
    props = $[3];
    ref = $[4];
    t1 = $[5];
  }
  const defaultHidden = t1 === undefined ? false : t1;
  const t = useTranslations();
  const [isHide, setIsHide] = useState(defaultHidden);
  let t2;
  if ($[6] !== hasError || $[7] !== isHide || $[8] !== maxLength) {
    let t3;
    if ($[10] !== hasError || $[11] !== isHide) {
      t3 = (_, index) => <div key={index}>{isHide ? <InputOTPSlotHide key={index} index={index} className={cn("header-4 bg-vive-primary-70 ring-vive-border-focus h-[34px] w-7 rounded-[5px] text-[18px] text-white backdrop-blur-[20px] md:h-12 md:w-10 md:text-[24px]", hasError && "border-vive-error border-[1.5px]")} dotClassName={cn("md:h-3 md:w-3 h-2 w-2")} caretClassName="bg-white" /> : <InputOTPSlot key={index} index={index} className={cn("header-4 bg-vive-primary-70 ring-vive-border-focus h-[34px] w-7 rounded-[5px] text-[18px] text-white backdrop-blur-[20px] md:h-12 md:w-10 md:text-[24px]", hasError && "border-vive-error border-[1.5px]")} caretClassName="bg-white" />}</div>;
      $[10] = hasError;
      $[11] = isHide;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = <InputOTPGroup className="gap-2">{Array.from({
        length: maxLength
      }, t3)}</InputOTPGroup>;
    $[6] = hasError;
    $[7] = isHide;
    $[8] = maxLength;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[13] !== maxLength || $[14] !== props || $[15] !== ref || $[16] !== t2) {
    t3 = <InputOTP ref={ref} {...props} maxLength={maxLength} pattern={"^(\\d+|\\*+)$"} containerClassName="w-max">{t2}</InputOTP>;
    $[13] = maxLength;
    $[14] = props;
    $[15] = ref;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsHide(_temp);
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== isHide) {
    t5 = <div className="cursor-pointer" onClick={t4}>{isHide ? <IconHide /> : <IconShow />}</div>;
    $[19] = isHide;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t3 || $[22] !== t5) {
    t6 = <div className="flex flex-row items-center gap-2">{t3}{t5}</div>;
    $[21] = t3;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== hasError || $[25] !== maxLength || $[26] !== t) {
    t7 = hasError && <div className="body-4">{t("profile-page.my-worlds-card-settings-passcode-caption", {
        count: maxLength
      })}</div>;
    $[24] = hasError;
    $[25] = maxLength;
    $[26] = t;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t6 || $[29] !== t7) {
    t8 = <div className="flex flex-col gap-4">{t6}{t7}</div>;
    $[28] = t6;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
}
function _temp(prev) {
  return !prev;
}
export default ViverseInputOTP;